import Stack from '@mui/material/Stack';

import { getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { KeyValueTable } from './KeyValueTable';
import { NoData } from './Illustrations/NoData';

export const BankInfoCmp_BankInfo_Fragment = graphql(`
  fragment BankInfoCmp_BankInfo_Fragment on BankInfo {
    accountOwner
    domiciliation
    bankCode
    branchCode
    accountNumber
    certificateKey
    iban
    swift
  }
`);

interface Props {
  readonly bankInfo?: FragmentType<typeof BankInfoCmp_BankInfo_Fragment> | null;
}

export const BankInfo = ({ bankInfo: pBankInfo }: Readonly<Props>) => {
  const bankInfo = getFragmentData(BankInfoCmp_BankInfo_Fragment, pBankInfo);

  if (!bankInfo) {
    return <NoData />;
  }

  return (
    <Stack sx={{ pt: 4, width: '100%' }}>
      <KeyValueTable
        ariaLabel="Informations bancaires"
        entries={[
          {
            id: 'accountOwner',
            label: 'Titulaire du compte',
            value: bankInfo.accountOwner,
          },
          {
            id: 'domiciliation',
            label: 'Domiciliation',
            value: bankInfo.domiciliation,
          },
          {
            id: 'bank',
            label: 'Code banque',
            value: bankInfo.bankCode,
          },
          {
            id: 'branch',
            label: 'Code guichet',
            value: bankInfo.branchCode,
          },
          {
            id: 'account',
            label: 'Numéro de compte',
            value: bankInfo.accountNumber,
          },
          {
            id: 'key',
            label: 'Clef RIB',
            value: bankInfo.certificateKey,
          },
          {
            id: 'iban',
            label: 'IBAN',
            value: bankInfo.iban,
          },
          {
            id: 'swift',
            label: 'BIC / SWIFT',
            value: bankInfo.swift,
          },
        ]}
      />
    </Stack>
  );
};
